import {observer} from "mobx-react";
import {Box} from "@mui/material";
import React from "react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import type {IPlayerTooltipController} from "views/components/modals/player_tooltip/player_tooltip.controller";
import styled from "@emotion/styled";
import {media} from "assets/css/media";

const TooltipContainer = styled(Box)`
	position: fixed;
	overflow: auto;
	bottom: 7%;
	left: 0;
	width: 100%;
	background: transparent;
	z-index: 9999;
	display: flex;
	align-items: center;
	justify-content: center;
	transform: translateX(-100%);
	transition: all ease 0.5s;

	&.open {
		transform: translateX(0);
		@media (max-width: ${media.mobile}) {
			transform: translateX(0);
		}
	}
`;
const TooltipMessage = styled(Box)`
	padding: 12px 24px;
	box-sizing: border-box;
	border: 1px solid var(--secondaryColor);
	font-size: 14px;
	color: #000;
	background: #fff;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const PlayerTooltip: React.FC = observer(() => {
	const {tooltipData} = useViewController<IPlayerTooltipController>(
		Bindings.PlayerTooltipController
	);

	return (
		<TooltipContainer className={tooltipData.isOpen ? "open" : ""}>
			<TooltipMessage>{tooltipData.message}</TooltipMessage>
		</TooltipContainer>
	);
});
